"use client";

import { useEffect, useState } from "react";
import { extractFbclid } from "./utils";

export function useFbclid() {
	const [fbclid, setFbclid] = useState<string | null>(null);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const id = extractFbclid(window.location.href);

			if (id) {
				setFbclid(id);
			}
		}
	}, []);

	return fbclid;
}
